import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface NexisBreadcrumbProps {
  projectTitle?: string;
  currentStep?: string;
}

export function NexisBreadcrumb({ projectTitle, currentStep }: NexisBreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1.5 text-sm text-muted-foreground mb-4 md:mb-6 flex-wrap">
      <Link
        to="/app/nexis-ai"
        className="hover:text-foreground transition-colors font-medium"
      >
        Nexis AI
      </Link>
      {projectTitle && (
        <>
          <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" />
          <span className="text-foreground font-medium truncate max-w-[200px] md:max-w-[300px]">
            {projectTitle}
          </span>
        </>
      )}
      {currentStep && (
        <>
          <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" />
          <span className="text-foreground/70">{currentStep}</span>
        </>
      )}
    </nav>
  );
}
